function padWithZeros(length?: number): number {
  const paddedNumber = `1${'0'.repeat(length || 2)}`;

  return parseInt(paddedNumber, 10);
}

export const roundFloatNumber = (number: number, length?: number) =>
  Math.round(number * padWithZeros(length)) / padWithZeros(length);

export const roundFloatNumberLastSevenNumber = (number: number) => Math.round(number * 10000000) / 10000000;
